import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";
import * as messageService from "../../../models/services/messageService";
//import * as userService from "../../../models/services/userService";
import { Translations } from "ui/Scripts/source/models/translations";
import { IListFilterItem, ListFilterItem } from "../../../models/common/listFilterItem";
import { ISavedListFilter } from "../../../models/common/savedListFilter";
import { ITypedOption } from "../../../models/common/typedOption";
import { IReportItem } from "../../../models/report/reportItem";
import { recordLockManager } from "../../../models/services/recordLockService";
import { IAppSessionState } from "../../../models/store/storeTypes";
import { HeaderMenuItem, NavigationMenu } from "../../app/NavigationMenu";
import { ListFilterSaveDialog } from "../../framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "../../framework/Page/PageContainer";
import { PageContent } from "../../framework/Page/PageContent";
import { IPageNavMenuItem } from "../../framework/PageNav/PageNavMenuItems";
// import { PageListAndReportsContainer } from "../../framework/Page/PageListAndReportsContainer";
import { ICodeTitle } from "source/models/common/codeTitle";
import { IMessagePage } from "source/models/message/messagePage";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { UserMenu } from "../../app/UserMenu";
import { PageTopBar } from "../../framework/Page/PageTopBar";
import { FilterTabs } from "../../framework/PageNavMenuItem/FilterTabs";
import { MessageFilterDrawer } from "../MessageFilterDrawer";
import { MessageList } from "../MessageList/MessageList";
import { MessageSettingsDialog, MessageSettingsDialogMenuItem } from "../MessageSettingsDialog";
import { abortManager } from "source/models/services/tokenService";
import { getMessagePageGeneralFilterFromState, getMessagePageFilterStateFromGeneralFilter, IMessagePageFilterState } from "../MessagePageFilter";

// MessagePage
export interface IMessagePageOwnProps {
}

export interface IMessagePageStateProps {
    appState: IAppSessionState;
    dataId: number;
    messagePage: IMessagePage;
}

export interface IMessagePageDispatchProps {
    onGetMessagePage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

type MessagePageProp = IMessagePageOwnProps & IMessagePageStateProps & IMessagePageDispatchProps;

interface IMessagePageState extends IMessagePageFilterState {
    initialized: boolean;
    listDataPreloaded: boolean;
    units: IIdTitleNode[];
    companies: IIdTitle[];
    modifyUsers: IIdTitle[];
    dynamicTimeFilters: IIdTitle[];
    activeCompanyId: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    settingsActions: IPageNavMenuItem[];
    // Filters
    listEditMode: boolean;
    listFilterIsSet: boolean;
    showListFilter: boolean;
    listFilterFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Permissions
    dataId: number;
    // Settings
    showSettingsDialog: boolean;
}

export class MessagePage extends React.Component<MessagePageProp, IMessagePageState> {
    getUnits = (units: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        return result.concat(units);
    };
    
    getIdTitles = (idTitles: IIdTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        return result.concat(idTitles);
    };

    getModifyUsers = (modifyUsers: ICodeTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        return result.concat(modifyUsers.map(i => IdTitle.createIdTitle(i.code, i.title)));
    };
    
    getDynamicTimeFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("0", "'" + Translations.SpecifedTimeFrame + "'"));
        result.push(IdTitle.createIdTitle("1", Translations.Last7Days));
        result.push(IdTitle.createIdTitle("2", Translations.Last30Days));
        result.push(IdTitle.createIdTitle("3", Translations.LastYear));
        result.push(IdTitle.createIdTitle("7", Translations.CurrentCalendarWeek));
        result.push(IdTitle.createIdTitle("8", Translations.CurrentCalendarMonth));
        result.push(IdTitle.createIdTitle("9", Translations.CurrentCalendarYear));
        result.push(IdTitle.createIdTitle("4", Translations.PreviousCalendarWeek));
        result.push(IdTitle.createIdTitle("5", Translations.PreviousCalendarMonth));
        result.push(IdTitle.createIdTitle("6", Translations.PreviousCalendarYear));
        return result;
    };

    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        return result;
    };
    
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.CurrentTopics, Translations.CurrentTopics, getMessagePageGeneralFilterFromState(null), "date", false, 0));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getListFilterIsSet = (state: IMessagePageState): boolean => {
        return MessageFilterDrawer.filterIsSet(state, state);
    };

    getSettingsActions = (activeCompanyId: string, canEditOtherCompanyPermissions: boolean, canEditModuleProperties: boolean, canEditAllModuleProperties: boolean): IPageNavMenuItem[] => {
        const result: IPageNavMenuItem[] = [];
        if (canEditAllModuleProperties) {
            result.push({ id: MessageSettingsDialogMenuItem.Units, title: Translations.Units });
            result.push({ id: MessageSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
            if (canEditOtherCompanyPermissions) {
                result.push({ id: MessageSettingsDialogMenuItem.PermissionsOtherCompanies, title: Translations.PermissionsOtherCompanies });
            }
        }
        if (canEditModuleProperties) {
            result.push({ id: MessageSettingsDialogMenuItem.MessageTypes, title: Translations.MessageTypes });
        }
        return result;
    };

    constructor(props: MessagePageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filterProps = ListFilterItem.getFilterProps(filters[0], "", true, getMessagePageFilterStateFromGeneralFilter);
        const dynamicTimeFilters = this.getDynamicTimeFilters();
        const state = {
            ...filterProps,
            initialized: !!props.messagePage,
            activeCompanyId: sessionState.companyId,
            listDataPreloaded: true,
            units: this.getUnits(props.messagePage?.units ?? []),
            companies: this.getIdTitles(props.messagePage?.filterCompanies ?? []),
            modifyUsers: this.getModifyUsers(props.messagePage?.modifyUsers ?? []),
            dynamicTimeFilters,
            selectedStartDate: 0,
            selectedEndDate: 0,
            selectedDynamicTimeFilterId: dynamicTimeFilters[0].id,
            settingsActions: this.getSettingsActions(sessionState.companyId, props.messagePage?.canEditOtherCompanyPermissions, props.messagePage?.canEditModuleProperties, props.messagePage?.canEditAllModuleProperties),
            // Filters
            listEditMode: false,
            listFilterIsSet: false,
            activeFilterId: filters[0].id,
            activeSavedFilterId: "",
            filters,
            savedFilters: ListFilterItem.getListFilterItems(props.messagePage?.companyFilters, props.messagePage?.userFilters),
            showListFilter: false,
            listFilterFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Permissions
            dataId: props.dataId,
            // Settings
            showSettingsDialog: false,
        };
        this.state = {
            ...state,
            //dashBoardPanels: SavedChartPanel.getDashBoardPanels(props.messagePage?.panels, props.messagePage?.chartPanels, state.chartItems, ApplicationPermissionType.Message),
            listFilterIsSet: this.getListFilterIsSet(state)
        };
    }

    // getReports = async (companyId: string) => {
    //     const state = this.state;
    //     const newState = await ReportItems.getReportsState(companyId, state.activeReportId, this.getHtlmlReportItems(), eventService.getEventPageReportItems,
    //         () => {
    //             if (!this._isMounted) return;
    //             this.setState({ loadingReports: true });
    //         },
    //         () => {
    //             if (!this._isMounted) return;
    //             this.setState({ loadingReports: false });
    //         });
    //     if (!this._isMounted || !newState) return;
    //     const props = this.props;
    //     this.setState({
    //         ...newState,
    //         dashBoardPanels: SavedChartPanel.getDashBoardPanels(props.messagePage?.panels, props.messagePage?.chartPanels, newState.chartItems, ApplicationPermissionType.Message)
    //     });
    // };

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
        this.props.onGetMessagePage();
        // this.getReports(sessionState.companyId);
    }

    componentDidUpdate(prevProps: MessagePageProp, prevState: IMessagePageState): void {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const equalCompanyIds = Base.equalStrArrays(prevProps.messagePage?.companies.map(i => i.id) ?? [], props.messagePage?.companies.map(i => i.id) ?? []);
        const prevCompanyId = prevProps.messagePage && prevProps.messagePage.companies.length > 0 ? prevProps.messagePage.companies[0].id : sessionState.companyId;
        const companyId = props.messagePage && props.messagePage.companies.length > 0 ? props.messagePage.companies[0].id : sessionState.companyId;
        const prevCanEditMessages = prevProps.messagePage?.canEditMessages ?? false;
        const canEditMessages = props.messagePage?.canEditMessages ?? false;
        const prevCanEditModuleProperties = prevProps.messagePage?.canEditModuleProperties ?? false;
        const canEditModuleProperties = props.messagePage?.canEditModuleProperties ?? false;
        const prevCanEditOtherCompanyPermissions = prevProps.messagePage?.canEditOtherCompanyPermissions ?? false;
        const canEditOtherCompanyPermissions = props.messagePage?.canEditOtherCompanyPermissions ?? false;
        const unitsData = props.messagePage?.units ?? [];
        const equalUnits = IdTitleNode.equalIds(prevProps.messagePage?.units ?? [], unitsData);
        const units = this.getUnits(unitsData);
        const companiesData = props.messagePage?.filterCompanies ?? [];
        const equalCompanies = IdTitle.equal(prevProps.messagePage?.filterCompanies ?? [], companiesData);
        const companies = this.getIdTitles(companiesData);
        const modifyUsersData = props.messagePage?.modifyUsers ?? [];
        const equalModifyUsers = IdTitle.equal(prevProps.messagePage?.modifyUsers ?? [], modifyUsersData);
        const modifyUsers = this.getModifyUsers(modifyUsersData);
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCanEditMessages === canEditMessages &&
            prevCanEditModuleProperties === canEditModuleProperties && prevCanEditOtherCompanyPermissions === canEditOtherCompanyPermissions &&
            equalCompanyIds && equalUnits && equalCompanies && equalModifyUsers) return;
        const savedFilters = ListFilterItem.getListFilterItems(props.messagePage?.companyFilters, props.messagePage?.userFilters);
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const selectedCompanyIds = equalCompanies ? state.selectedCompanyIds : [Base.emptyGuid];
        const selectedModifyUserCodes = equalModifyUsers ? state.selectedModifyUserCodes : [""];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            dataId: props.dataId,
            initialized: !!props.messagePage,
            //dashBoardPanels: SavedChartPanel.getDashBoardPanels(props.messagePage?.panels, props.messagePage?.chartPanels, state.chartItems, ApplicationPermissionType.Message),
            //activeViewTypeId: companyId !== sessionState.companyId ? MessagePageViewTypeId.Records : state.activeViewTypeId,
            activeCompanyId: companyId,
            units,
            companies,
            modifyUsers,
            selectedUnitIds,
            selectedCompanyIds,
            selectedModifyUserCodes,
            savedFilters,
            activeSavedFilterId,
            settingsActions: this.getSettingsActions(companyId, props.messagePage?.canEditOtherCompanyPermissions, props.messagePage?.canEditModuleProperties, props.messagePage?.canEditAllModuleProperties)
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    }

    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem) => {
        const state = this.state;
        let result = {
            selectedStartDate: state.selectedStartDate,
            selectedEndDate: state.selectedEndDate,
            selectedUnitIds: state.selectedUnitIds,
            selectedCompanyIds: state.selectedCompanyIds,
            selectedModifyUserCodes: state.selectedModifyUserCodes,
            selectedDynamicTimeFilterId: state.selectedDynamicTimeFilterId,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            result = ListFilterItem.getFilterProps(listItemFilter, result.sortColumn, result.sortOrderIsAsc, getMessagePageFilterStateFromGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshPageData(companyId, this.state.listEditMode);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return {};
        const filterProps = this.getFilterPropsWithState(filter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return {};
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Message);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showListFilter: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            listFilterFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, getMessagePageGeneralFilterFromState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.Message);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: getMessagePageGeneralFilterFromState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleShowListFilter = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showListFilter: true, //this.state.activeViewTypeId !== MessagePageViewTypeId.Reports,
            listFilterFilter: filter
        });
    };

    handleListFilterPanelOk = (closeDialog: boolean, newFilterState: IMessagePageFilterState): any => {
        const newState = {
            ...this.state,
            ...newFilterState
        };
        this.setState({
            showListFilter: !closeDialog,
            ...newFilterState,
            dataId: this.state.dataId + 1,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return getMessagePageGeneralFilterFromState(newState);
    };
    
    handleFilterPanelCancel = () => {
        this.setState({ showListFilter: false });
    };
    // #endregion Record Filter

    // #region Units
    handleRefreshPageData = async (companyId: string, listEditMode: boolean) => {
        const sessionState = this.props.appState.state;
        const pageData = await messageService.getMessagePageData(companyId, listEditMode);
        if (!pageData) return;
        const state = this.state;
        //Units
        const units = this.getUnits(pageData.units);
        const selectedUnitIds = IdTitleNode.keepAvailableSelectedIds(units, state.selectedUnitIds);
        //Companies
        const companies = this.getIdTitles(pageData.filterCompanies);
        const selectedCompanyIds = Base.keepAvailableSelectedIds(companies, state.selectedCompanyIds);
        //ModifyUsers
        const modifyUsers = this.getModifyUsers(pageData.modifyUsers);
        const selectedModifyUserCodes = Base.keepAvailableSelectedIds(modifyUsers, state.selectedModifyUserCodes, "");
        const stateChange = {
            activeCompanyId: companyId,
            listEditMode,
            units,
            companies,
            modifyUsers,
            selectedUnitIds,
            selectedCompanyIds,
            selectedModifyUserCodes,
            settingsActions: this.getSettingsActions(sessionState.companyId, pageData.canEditOtherCompanyPermissions, pageData.canEditModuleProperties, pageData.canEditAllModuleProperties)
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };
    // #endregion Units

    handleChangeListEditMode = (listEditMode: boolean) => {
        const sessionState = this.props.appState.state;
        const companyId = listEditMode
            ? this.state.activeCompanyId
            : sessionState.companyId;
        return this.handleRefreshPageData(companyId, listEditMode);
    };

    // #region Settings
    handleOpenSettingsDialog = () => {
        this.setState({
            showSettingsDialog: true
        });
    };
    
    handleSettingsDialogOk = async (refreshView: boolean) => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        if (!refreshView) return;
        await this.handleRefreshPageData(this.state.activeCompanyId, this.state.listEditMode);
    };
    // #endregion Settings

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.messagePage ? props.messagePage.companies : [];
        //const settingsVisible = state.settingsActions?.length > 0;
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.CurrentTopics}
                    companies={state.listEditMode ? companies : null}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar>
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    <MessageList
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        editMode={state.listEditMode}
                        canEditMessages={props.messagePage?.canEditMessages ?? false}
                        settingsActions={state.settingsActions}
                        savedFilter={state.activeSavedFilterId ? state.savedFilters.find(i => i.id === state.activeSavedFilterId) : null}
                        dataId={state.dataId.toString(10)}
                        preloaded={state.listDataPreloaded}
                        list={props.messagePage?.list}
                        listFilterIsSet={state.listFilterIsSet}
                        units={state.units}
                        selectedStartDate={state.selectedStartDate}
                        selectedEndDate={state.selectedEndDate}
                        selectedUnitIds={state.selectedUnitIds}
                        selectedCompanyIds={state.selectedCompanyIds}
                        selectedModifyUserCodes={state.selectedModifyUserCodes}
                        selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        onSetSortData={this.handleFilterSortData}
                        onLoadPageData={() => this.handleRefreshPageData(this.state.activeCompanyId, this.state.listEditMode)}
                        onOpenFiltersDialog={this.handleShowListFilter}
                        onOpenSettingsDialog={this.handleOpenSettingsDialog}
                        onChangeEditMode={this.handleChangeListEditMode}
                        reportTabs={(
                            <FilterTabs
                                items={state.savedFilters}
                                standardFilters={state.filters}
                                selectedId={this.state.activeFilterId}
                                selectedSavedId={this.state.activeSavedFilterId}
                                onSetActiveItem={this.handleChangeActiveSavedFilter}
                                onSetActiveStandardItem={this.handleChangeActiveFilter}
                            />
                        )}
                    />
                </PageContent>
                <MessageFilterDrawer
                    open={state.showListFilter}
                    filter={state.listFilterFilter}
                    units={state.units}
                    companies={state.companies}
                    modifyUsers={state.modifyUsers}
                    dynamicTimeFilters={state.dynamicTimeFilters}
                    selectedUnitIds={state.selectedUnitIds}
                    selectedCompanyIds={state.selectedCompanyIds}
                    selectedModifyUserCodes={state.selectedModifyUserCodes}
                    selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                    selectedStartDate={state.selectedStartDate}
                    selectedEndDate={state.selectedEndDate}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.handleListFilterPanelOk}
                    onCancel={this.handleFilterPanelCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Message}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <MessageSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        settingsActions={state.settingsActions}
                        onClose={this.handleSettingsDialogOk}
                    />
                }
            </PageContainer>
        );
    }
}